import { CombinedGraphQLErrors } from '@apollo/client/errors'
import { onError } from '@apollo/client/link/error'

import {
  isApolloGraphqlResultInfrastructureFailure,
  isApolloNetworkInfrastructureFailure,
  notifyServiceLikelyDown,
} from '@/services/serviceReachabilityMonitor'

/**
 * When the GraphQL endpoint fails (transport, 5xx, or GraphQL errors carrying 5xx / gateway codes),
 * poll until the API responds again and notify via {@link notifyServiceLikelyDown}.
 */
export const ApolloServiceReachabilityLink = onError(({ error }) => {
  if (isApolloNetworkInfrastructureFailure(error)) {
    notifyServiceLikelyDown()
    return
  }
  if (
    CombinedGraphQLErrors.is(error) &&
    isApolloGraphqlResultInfrastructureFailure(error.errors)
  ) {
    notifyServiceLikelyDown()
  }
})
